<!-- 库存属性调整操作 -->
<template>
   <div>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'"
                  :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                  @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form class="baseForm" id="mainInfo" :show-message="false" label-width="100px"
                              :model="sendDataInfo" ref="sendDataInfo" size="mini">
                              <el-row v-if="dataActionBox.actionType != 2">
                                 <el-form-item :label="formOneValue.showField"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                    :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1"
                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <template>
                                       <!-- 库房 -->
                                       <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item"
                                          :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                          effect="dark" :content="sendDataInfo.stName" placement="bottom-start">
                                          <el-input class="form_codition" v-model.trim="sendDataInfo.stName"
                                             :maxlength="$store.state.inputLength"
                                             @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                             :disabled="formOneValue.isChange == 0">
                                             <el-button
                                                @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                slot="append" icon="el-icon-search"></el-button>
                                          </el-input>
                                       </el-tooltip>
                                       <el-date-picker v-else-if="formOneValue.fieldType == 'date'"
                                       @change="(val)=>{ changeTime(val,formOneValue.entityField) }"
                                          :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                          v-model="sendDataInfo[formOneValue.entityField]" type="date"
                                          placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                                       </el-date-picker>
                                       <el-select clearable size="mini"
                                          v-else-if="formOneValue.entityField == 'isHis'"
                                          :disabled="sendDataInfo.agrType==2"
                                          @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]"
                                          placeholder="请选择">
                                          <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)"
                                             :key="matItem.key"
                                             :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                             :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                       </el-select>
                                       <el-select clearable size="mini"
                                          v-else-if="formOneValue.fieldType == 'formatter'"
                                          @visible-change="selectChange" :disabled="formOneValue.isChange == 0"
                                          @change="selectChange1(formOneValue.entityField)" v-model="sendDataInfo[formOneValue.entityField]"
                                          placeholder="请选择">
                                          <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)"
                                             :key="matItem.key"
                                             :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                             :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                       </el-select>
                                       <div id="manrange" v-else-if="formOneValue.entityField == 'smList'">
                                          <div class="cmContent">
                                             <el-button v-if="dataActionBox.actionType < 2" class="cmButton"
                                                @click="openRange()" type="info" plain size="mini">选择供应商</el-button>
                                             <el-input type="textarea" v-model="smNameStr" readonly>
                                             </el-input>
                                          </div>
                                       </div>
                                       <el-input class="form_codition" v-else
                                          v-model.trim="sendDataInfo[formOneValue.entityField]"
                                          @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                          :maxlength="$store.state.inputLength"
                                          :disabled="formOneValue.isChange == 0"></el-input>
                                    </template>

                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                          sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <div id="manrange" v-else-if="formOneValue.entityField == 'smList'">
                                       <div class="cmContent">
                                          <el-input type="textarea" v-model="smNameStr" readonly>
                                          </el-input>
                                       </div>
                                    </div>
                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                       {{ getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField,
                                          formOneValue.fieldType, formOneValue.formatterContent) }}
                                    </span>
                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>

                           <!-- 明细 -->
                           <el-form :inline="true" size="mini">
                              <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                 <el-button type="primary" size="mini" @click="addDetails()">新增</el-button>
                                 <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                 </el-button>
                              </div>
                              <el-table size="mini" ref="mxTableRef" id="mxTable" :data="sendDataInfo.detailList" border
                                 style="width: 100%" :height="mxHeight">
                                 <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                    <template slot-scope="scope">
                                       <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border
                                          size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>
                                 <el-table-column align="center" show-overflow-tooltip :label="formOneValue.showField"
                                    :min-width="formOneValue.fieldWeight" v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey">
                                    <template slot-scope="scope">
                                       <el-input :ref="formOneValue.entityField"
                                          v-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2"
                                          v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, true)"
                                          clearable>
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, true)"
                                             slot="append" icon="el-icon-search"></el-button>
                                       </el-input>
                                       <el-select size="mini"
                                          v-else-if="formOneValue.entityField == 'rebateType' && dataActionBox.actionType != 2"
                                          :disabled="formOneValue.isChange == 0" @change="selectChanges(scope.$index)"
                                          v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          placeholder="请选择">
                                          <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)"
                                             :key="matItem.key"
                                             :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                             :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                       </el-select>
                                       <el-select size="mini"
                                          v-else-if="formOneValue.fieldType == 'formatter' && dataActionBox.actionType != 2"
                                          :disabled="formOneValue.isChange == 0" @change="$forceUpdate()"
                                          v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          placeholder="请选择">
                                          <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)"
                                             :key="matItem.key"
                                             :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                             :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key"></el-option>
                                       </el-select>
                                       <el-input @mousewheel.native.prevent :ref="formOneValue.entityField"
                                          v-else-if="formOneValue.entityField == 'rebatePoint' && dataActionBox.actionType != 2 && sendDataInfo.detailList[scope.$index].rebateType == 2"
                                          v-model.trim="sendDataInfo.detailList[scope.$index].rebatePoint" type="number"
                                          :disabled="formOneValue.isChange == 0">
                                       </el-input>
                                       <el-input @mousewheel.native.prevent :ref="formOneValue.entityField"
                                          v-else-if="formOneValue.entityField == 'rebateAmount' && dataActionBox.actionType != 2 && (sendDataInfo.detailList[scope.$index].rebateType == 1 || sendDataInfo.detailList[scope.$index].rebateType == 3)"
                                          v-model.trim="sendDataInfo.detailList[scope.$index].rebateAmount"
                                          type="number" :disabled="formOneValue.isChange == 0">
                                       </el-input>
                                       <!-- 旧日期 -->
                                       <span v-else-if="formOneValue.fieldType == 'date'">
                                          <span v-if="scope.row[formOneValue.entityField]">
                                             {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                          </span>
                                       </span>
                                       <span v-else-if="formOneValue.fieldType == 'formatter'">
                                          {{ getValue(sendDataInfo.detailList[scope.$index][formOneValue.entityField],
                                             formOneValue.entityField,
                                             formOneValue.fieldType, formOneValue.formatterContent) }}
                                       </span>
                                       <span v-else>
                                          {{ scope.row[formOneValue.entityField] }}
                                       </span>
                                    </template>
                                 </el-table-column>
                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo"
               @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
         </div>
      </div>
      <!-- 检索方案弹窗 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
         :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
            @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog v-if="dialogRange" :visible.sync="dialogRange" width="1000px" :modal-append-to-body='true'
         :append-to-body="true">
         <shuttleTable ref="searchScheme" :dataList="dataList" @openClick="openClick" @closeClick="closeClick" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "rebateAgreementAction",
   props: ['actionData'],
   //import引入的组件需要注入到对象中才能使用
   components: {
      // ExtractionScheme,
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         showTabs: "",
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {},
         detaislDataInfo: {},
         formDataList: [],
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
         seTitle: "", //检索
         DialogVisible: false,
         seWidth: "0",
         seId: 0,
         seType: "",
         sField: "",
         fField: "",
         datailsFlag: false,
         parentSearchData: {},
         selectedDetailsIndex: 0, //选择索引
         newTime: '',
         newDayTime: '',
         inputel: [],
         dialogRange: false,
         dataList: {
            leftList: [],
            rightList: [],
            list: [],
            nameList: [
               {
                  entityField: "smName",
                  showField: "供应商名称",
                  fieldWeight: 200,
               }
            ],
         },
         smNameList: [],
         smNameStr: "",
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.detailList": {
         handler: function (newValue, oldValue) {
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      changeTime(val,type){
         if (type=='endTime') {
            if (this.sendDataInfo.endTime) {
               var time = val + 24 * 60 * 60 * 1000 - 1;
               this.sendDataInfo.endTime=time
            }
         }
      },
      getValue(val, type, fieldType, arr) {
         var str = ""
         if (type == 'bgiType' || fieldType == 'formatter') {
            if (arr) {
               JSON.parse(arr).forEach(item => {
                  if (String(Number(item.value)) != NaN && item.value == val) {
                     str = item.key
                  } else if (String(Number(item.key)) != NaN && item.key == val) {
                     str = item.value
                  }
               })
            }
         } else {
            str = val || ""
         }
         return String(str)
      },
      // 打开选择范围
      openRange() {
         this.dataList.leftList = this.dataList.list.filter(item => {
            return this.smNameList.indexOf(item) == -1;
         });
         this.dataList.rightList = this.smNameList
         this.dialogRange = true;
      },
      openClick(val) {
         this.smNameList = val
         this.smNameStr = val.map(item => {
            return item.smName
         }).join()
         this.sendDataInfo.smList = val.map(item => {
            return item.smId
         })
         this.dialogRange = false;
      },
      closeClick() {
         this.dialogRange = false;
      },
      selectChanges(index) {
         var info = this.sendDataInfo.detailList[index]
         if (info.rebateType == 1 || info.rebateType == 3) {
            info.rebatePoint = 0
         } else if (info.rebateType == 2) {
            info.rebateAmount = 0
         }
      },
      // 主表单select框切换enter切换焦点事件方法
      selectChange(e) {
         if (e == false) {
            for (let index = 0; index < this.inputel.length; index++) {
               if (this.inputel[index] == document.activeElement) {
                  this.nextFocus(index);
                  break;
               }
            }
         }
      },
      selectChange1(type){
         if (type=='agrType') {
            if (this.sendDataInfo.agrType==2) {
               this.sendDataInfo.isHis=1
            }
         }
      },
      // 输入框切换焦点
      nextFocus(index, fField) {
         if (index >= this.inputel.length - 1) {
            if (this.sendDataInfo.woApplyDetails.length > 0) {
            }
            this.addDetail("sendDataInfo");
            return;
         }
         if (fField == "keydown") {
            this.addDetail("sendDataInfo");
            return;
         }
         var aindex = index + 1;
         if (
            this.inputel[aindex].value != "" ||
            this.inputel[aindex].disabled
         ) {
            this.nextFocus(aindex);
            return;
         }
         this.$nextTick(() => {
            this.inputel[aindex].focus();
         });
      },
      getTimestamp() {
         this.newTime = new Date(new Date().toLocaleDateString()).getTime() - 1 * 24 * 3600 * 1000
         this.newDayTime = Number(this.$common.getNewDayTime() * 1 + 86400000)
      },
      showPrintPlan() { // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData
               .printJurId)
         } else {
            return
         }
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField, fField, flag) {
         this.DialogVisible = true;
         this.seId = sId;
         this.selectedDetailsIndex = index
         this.seType = type;
         this.sField = sField;
         this.fField = fField;
         if (flag) {
            this.datailsFlag = true
         } else {
            this.datailsFlag = false
         }
      },
      //检索带回数据
      changeInputModel(val) {
         console.log("返hui", val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false; //关闭商品检索窗口
            if (val.length > 0) {
               this.bgmSelect(val)
               return
            }
            //赋值给当前行
            if (val.bgmId) {
               console.log(val, this.sendDataInfo.detailList, this.selectedDetailsIndex)
               if (this.sendDataInfo.detailList.length == 0) {
                  this.addDetails()
               }
               var dataItem = {
                  ...this.detaislDataInfo
               }
               for (const key in val) {
                  if (dataItem[key] != undefined) {
                     dataItem[key] = val[key]
                  }
               }
               // 优化：直接更新，不需要setTimeout
               for (const key in dataItem) {
                  this.$set(this.sendDataInfo.detailList[this.selectedDetailsIndex], key, dataItem[key]);
               }
               console.log(this.sendDataInfo.detailList, "测试");

            }
         } else {
            this.DialogVisible = false;
         }
      },
      bgmSelect(val) {
         if (this.sendDataInfo.detailList.length == 0) {
            this.sendDataInfo.detailList = val
         } else {
            this.sendDataInfo.detailList.splice(this.selectedDetailsIndex, 1)
            val.forEach(item => {
               //赋值给当前行
               if (item.bgmId) {
                  var dataItem = {
                     ...this.detaislDataInfo
                  }
                  for (const key in item) {
                     if (dataItem[key] != undefined) {
                        dataItem[key] = item[key]
                     }
                  }
                  this.sendDataInfo.detailList.push({})
                  var index = this.sendDataInfo.detailList.length - 1
                  // 优化：直接更新，不需要setTimeout
                  for (const key in dataItem) {
                     this.$set(
                        this.sendDataInfo.detailList[index],
                        key,
                        dataItem[key]
                     );
                  }
               }
            })
         }

      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      // 确认新增
      async sendDataAction(formName) {
         let flag = false;
         this.$refs[formName].validate((valid) => {
            if (valid) { } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               flag = true;
               return false;
            }
         });
         if (flag) return false;
         let responseData;
         if (this.dataActionBox.actionType == 0) {
            responseData = await this.$http.rebateAgreementadd(
               this.sendDataInfo
            );
         } else {
            responseData = await this.$http.rebateAgreementupdate(
               this.sendDataInfo
            );
         }
         if (responseData.status == 200) {
            this.$emit('drawerCancel', 1)
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });

            // this.$parent.getDataList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      //取消新增
      initActionBox(formName) {
         this.$confirm("确定取消新增吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit('drawerCancel', 0)
               this.init();
               this.$refs[formName].resetFields();
            })
            .catch(() => { });
      },

      // 初始化
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }

         this.sendDataInfo.chamAppdate = new Date().getTime(); //申请时间
         this.sendDataInfo.detailList = [];
      },

      //新增明细
      addDetails() {
         this.$refs['sendDataInfo'].validate((valid) => {
            if (valid) {
               var flag = false
               if (this.sendDataInfo.detailList.length > 0) {
                  this.sendDataInfo.detailList.forEach(item => {
                     if (item.bgmId == "") {
                        flag = true
                        this.$nextTick(() => {
                           this.selectedDetailsIndex = Number(
                              this.sendDataInfo.detailList.length - 1
                           );
                           this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                           let refsElTable = this.$refs.mxTableRef;
                           refsElTable.clearSelection();
                           refsElTable.toggleRowSelection(
                              this.sendDataInfo.detailList[this.selectedDetailsIndex]
                           );
                        });
                     }
                  })
               }
               if (flag) {
                  return
               }
               this.sendDataInfo.detailList.push({})
               var index = this.sendDataInfo.detailList.length - 1
               for (const key in this.detaislDataInfo) {
                  this.$set(this.sendDataInfo.detailList[index], key, this.detaislDataInfo[key])
               }
               this.$nextTick(() => {
                  this.selectedDetailsIndex = Number(
                     this.sendDataInfo.detailList.length - 1
                  );
                  this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.detailList[this.selectedDetailsIndex]
                  );
               });
            } else {
               this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
               return false;
            }
         });

      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         this.seIndex = index;
         if (field == "keydown") {
            if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
               this.$refs["bgmName"][index + 1].focus();
               this.selectedDetailsIndex = index + 1;
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                  );
               });
               return;
            }
            this.addDetails("sendDataInfo");
            return;
         }
         this.$refs[field][index].focus();
      },
      //删除明细
      deleteDetails() {
         if (this.sendDataInfo.detailList.length < 1) {
            this.$message({
               message: "请先添加明细",
               type: "error",
            });
            return false;
         }
         this.sendDataInfo.detailList.splice(this.selectedDetailsIndex, 1);
         this.selectedDetailsIndex = 0;
      },
      async isShowData(name, value) {
         switch (name) {
            case "cargoOwner":
               var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.sendDataInfo.coId = dataInfo.coId;
                  this.sendDataInfo.newCoName = dataInfo.coName;
               }
               break;
         }
      },

      // 父级传入
      openBox(cate, formData, oldData = "") {
         this.dataActionBox.actionType = this.actionData.cate
         this.formDataList = this.actionData.formData
         var oldData = this.actionData.oldData
         this.filterMainField()
         this.showTabs = this.actionData.formData[0].jciName
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
         } else {
            this.dataActionBox.boxTitle = '查看信息'
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
         }
         this.smNamequery()
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getHeight()
               }
               this.initFocus()
            }, 16.7)
         })
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
               this.mxForm.forEach(item1 => {
                  if (item1.fieldType == 'number') {
                     if (item1.defaultValue) {
                        this.$set(this.detaislDataInfo, item1.entityField, Number(item1.defaultValue))
                     } else {
                        this.$set(this.detaislDataInfo, item1.entityField, 0)
                     }
                  } else if (item1.fieldType == 'search' && item1.setField) {
                     var arr = item1.setField.split(',')
                     arr.forEach(item2 => {
                        this.$set(this.detaislDataInfo, item2, "")
                     })
                  } else {
                     if (item1.defaultValue !== "" && item1.defaultValue != null) {
                        this.$set(this.detaislDataInfo, item1.entityField, String(Number(item1.defaultValue)) == 'NaN' ? item1.defaultValue : Number(item1.defaultValue))
                     } else {
                        this.$set(this.detaislDataInfo, item1.entityField, "")
                     }
                  }
               })
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            var index1 = 0
            for (let index = 0; index < key.jurconfigform.length; index++) {
               // if (key.jurconfigform[index].isShow == 1)
               if (key.jurconfigform[index].isShow == 1) {
                  key.jurconfigform[index].isIndex = index1
                  index1++
               }
               this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

            }
         });
         var arr = [{ entityField: "detailList" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.$set(this.sendDataInfo, "chamAppdate", new Date().getTime())
         this.$set(this.sendDataInfo, "actionType", 0)
         this.$set(this.sendDataInfo, "smList", [])
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == "") {
               this.inputel[index].focus();
               break;
            }
         }
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById("mainInfo");
         if (el) this.inputel = el.getElementsByTagName("input");
      },
      async smNamequery() {
         const res = await this.$http.rebateAgreementgetSmInfoList({
            smName: "",
         })
         console.log(res);
         if (res.status == 200) {
            this.dataList.leftList = JSON.parse(JSON.stringify(res.result))
            this.dataList.list = JSON.parse(JSON.stringify(res.result))
            this.dataList.rightList = []
            if (this.sendDataInfo.smList.length > 0) {
               // 优化后的代码：使用 Set 提高查找效率
               const smIdSet = new Set(this.sendDataInfo.smList);
               this.smNameList = this.dataList.list.filter(item => smIdSet.has(item.smId));
               this.smNameStr = this.smNameList.map(item => item.smName).join()
            }
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox()
      })
      this.getTimestamp()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput();
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.el-drawer {
   outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}
</style>